import React, {useEffect, useRef} from 'react';
import {JitsiRecorderProps} from "./types";

const JitsiRecorder: React.FC<JitsiRecorderProps> = ({
    roomName,
    jwtToken,
    domain,
    medasVoiceUrl,
}) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const separator = medasVoiceUrl.includes("?") ? "&" : "?";
    const iframeSrc = `${medasVoiceUrl}${separator}room=${encodeURIComponent(roomName)}&domain=${encodeURIComponent(domain)}&jitsiToken=${encodeURIComponent(jwtToken)}`;

    useEffect(() => {
        const handleDisconnect = () => {
            if (iframeRef.current && iframeRef.current.contentWindow) {
                console.log("[JitsiRecorder] Sending disconnect message to iframe");
                iframeRef.current.contentWindow.postMessage({ type: 'medasvoice:recording:stop_and_finalize' }, '*');
            }
        };

        window.addEventListener('jitsi.disconnecting', handleDisconnect);

        return () => {
            window.removeEventListener('jitsi.disconnecting', handleDisconnect);
        };
    }, []);

    const handleIframeLoad = () => {
        console.log("[JitsiRecorder] Iframe loaded successfully:", iframeSrc);
    };

    const handleIframeError = (e: any) => {
        console.error("[JitsiRecorder] Iframe failed to load:", iframeSrc, e);
    };

    return (
        <div className="jitsi-recorder">
            <iframe
                ref={iframeRef}
                src={iframeSrc}
                style={{width: '100%', height: '95px', border: 'none'}}
                allow="camera; microphone;camera; microphone; autoplay; fullscreen"
                onLoad={handleIframeLoad}
                onError={handleIframeError}
            />
        </div>
    );
};

export default JitsiRecorder;